import { inject, Injectable } from '@angular/core';

import { BaseStore, Language } from '@spartacus/core';
import Cookies from 'js-cookie';

import { DpFallbackLanguageService } from '@app/core/services/fallback-language.service';

@Injectable({ providedIn: 'root' })
export class DpLanguageSelectorService {
  readonly #fallbackLanguage = inject(DpFallbackLanguageService).fallbackLanguage;
  readonly #defaultLanguage = inject(DpFallbackLanguageService).defaultLanguage;

  getContextLanguage(language?: string, baseStore?: BaseStore): string {
    const availableLanguages = baseStore?.languages ?? [];

    const cookiesLanguage = this.#findLanguage(availableLanguages, Cookies.get('language'));
    if (cookiesLanguage) {
      return cookiesLanguage;
    }

    const contextLanguage = this.#findLanguage(availableLanguages, language);
    if (contextLanguage) {
      return contextLanguage;
    }

    const fallbackLanguage = this.#findLanguage(availableLanguages, this.#fallbackLanguage);
    if (fallbackLanguage) {
      return fallbackLanguage;
    }

    const defaultBaseStoreLanguage = this.#findLanguage(availableLanguages, baseStore?.defaultLanguage?.isocode);
    if (defaultBaseStoreLanguage) {
      return defaultBaseStoreLanguage;
    }

    return availableLanguages[0]?.isocode || this.#defaultLanguage;
  }

  #findLanguage(languages: Language[], languageCode?: string): string | undefined {
    return languages.find((language) => language.isocode === languageCode)?.isocode;
  }
}
